/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_SubtitleInputs */

const zh_hero_subtitle = /** @type {(inputs: Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让每一位老师都能轻松创作高质量教学内容`)
};

const en_hero_subtitle = /** @type {(inputs: Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empowering every teacher to create high-quality educational content effortlessly`)
};

const es_hero_subtitle = /** @type {(inputs: Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ayudando a cada profesor a crear contenido educativo de alta calidad sin esfuerzo`)
};

/**
* | output |
* | --- |
* | "Empowering every teacher to create high-quality educational content effortlessly" |
*
* @param {Hero_SubtitleInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const hero_subtitle = /** @type {((inputs?: Hero_SubtitleInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_SubtitleInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_hero_subtitle(inputs)
	if (locale === "en") return en_hero_subtitle(inputs)
	return es_hero_subtitle(inputs)
});